// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__255x4","fileBtn":"File_fileBtn__iuGKL","closeBtn":"File_closeBtn__2na6P","fileSelected":"File_fileSelected__874aQ","disabled":"File_disabled__2Mf1Y"};